import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RequestStatus } from "../../../model/ServiceRequestStatus.model";
import { userObject } from "../../../model/user-object/UserObject.model";
import { getAllSPAUserObjects, getEnterpriseApprovers, getSMCApprovers } from "../../../services/SPAAdmin/SPAUserObjects.api";

export interface CampaignUserObjectsState {
    userObjectList: {[key:string]:string},
    status: RequestStatus,
    error: string | undefined,
    enterpriseApprovers: userObject[];
    smcApprovers: userObject[];
    enterpriseStatus: RequestStatus;
    smcStatus: RequestStatus;
    enterpriseError: string | undefined;
    smcError: string | undefined;
}

export const initialState: CampaignUserObjectsState = {
    userObjectList: {},
    status: RequestStatus.idle,
    error: undefined,
    enterpriseApprovers: [],
    smcApprovers: [],
    enterpriseStatus: RequestStatus.idle,
    smcStatus: RequestStatus.idle,
    enterpriseError: undefined,
    smcError: undefined
}

export const CampaignUserObjectsSlice = createSlice({
    name: 'campaignUserObjects',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(getAllSPAUserObjects.pending, (state, action) => {
                state.status = RequestStatus.loading
            })
            .addCase(getAllSPAUserObjects.fulfilled, (state, action: PayloadAction<userObject[]>) => {
                state.status = RequestStatus.succeeded
                const result: {[key:string]:string} = {};
                action.payload.map((obj: userObject) => result[obj.id.toLowerCase()] = obj.displayName);
                state.userObjectList = result;
                state.error = undefined
            })
            .addCase(getAllSPAUserObjects.rejected, (state, action: any) => {
                state.status = RequestStatus.failed
                const message = (action?.payload && action.payload["Message"] ? action.payload["Message"] : action.error.message);
                state.error = "Campaigns User Objects: " + message;
            })
            // Enterprise approvers
            .addCase(getEnterpriseApprovers.pending, (state) => {
                state.enterpriseStatus = RequestStatus.loading;
                state.enterpriseError = undefined;
            })
            .addCase(getEnterpriseApprovers.fulfilled, (state, action) => {
                state.enterpriseStatus = RequestStatus.succeeded;
                state.enterpriseApprovers = action.payload;
                state.enterpriseError = undefined;
            })
            .addCase(getEnterpriseApprovers.rejected, (state, action) => {
                state.enterpriseStatus = RequestStatus.failed;
                state.enterpriseError = action.error.message;
                state.enterpriseApprovers = [];
            })
            // SMC approvers
            .addCase(getSMCApprovers.pending, (state) => {
                state.smcStatus = RequestStatus.loading;
                state.smcError = undefined;
            })
            .addCase(getSMCApprovers.fulfilled, (state, action) => {
                state.smcStatus = RequestStatus.succeeded;
                state.smcApprovers = action.payload;
                state.smcError = undefined;
            })
            .addCase(getSMCApprovers.rejected, (state, action) => {
                state.smcStatus = RequestStatus.failed;
                state.smcError = action.error.message;
                state.smcApprovers = [];
            });
    }
});

export const CampaignUserObjectsReducer = CampaignUserObjectsSlice.reducer;